export const AppVersions: Array<string> = ['5.0.0', '5.0.1', '5.0.2','5.0.3','5.0.4','5.0.5','5.0.6','5.0.7']; // this is for android/ios
export const ClientVersion = '14';
